import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { ContabilidadMaestrosService } from '../services/contabilidad-maestros.service';

@Component({
  selector: 'app-dashboard',
  standalone: true,
  imports: [CommonModule, RouterModule, MatIconModule, MatCardModule],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss',
})
export default class DashboardContabilidadMaestrosComponent implements OnInit {
  maestros: { nombre: string; ruta: string }[] = [];

  constructor(private readonly maestrosService: ContabilidadMaestrosService) {}

  ngOnInit(): void {
    this.maestros = this.maestrosService.getMaestros();
  }
}
